import React, { Component } from 'react';
import {
	Navbar, NavbarBrand, Nav, NavbarToggler, Collapse, NavItem, DropdownMenu, DropdownItem,
	DropdownToggle, Dropdown, Button, ListGroup, ListGroupItem, Modal, ModalHeader} from 'reactstrap';

import {Switch, Route, Redirect, NavLink, Link} from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import axios from 'axios';

//Components
import HomePage from './HomePageComponent';
import StudentCourseHomePage from './student/CourseHomePageComponent';
import AllProblemsPage from './AllProblemsPageComponent';
import PCourseHomePage from './professor/CourseHomePageComponent';
import News from './NewsComponent';
import ProblemDetails from './student/ProblemDetailsComponent';
import StudentPage from './student/StudentPageComponent';
import { SignupModal } from './SignupModalComponent';
import ModalAlert from './ModalAlertComponent';
import {SignupVerificationModal} from "./SignupVerificationModal";
import Sponsors from './SponsorsComponent';
import AboutWebGrade from './AboutWebGradeComponent';
import WebGradeTeam from './WebGradeTeamComponent';

//Data
import logo from '../assets/logo.png';
import { serverPath, convertDatetime } from "./common";

//Style
import '../css/navbar.css';
import {LoginModal} from "./LoginModalComponent";



class MainLayout extends Component {

	constructor(props) {
		super(props);

		this.state = {
			isNavOpen: false,
			dropdownOpen: false,
			dropdownOpen2: false,
			notificationsOpen: false,
			notificationsModalOpen: false,
			user: null,
            openLoginModal: false,
			notificationsData: [],
			allNotifications: [],
			modalAlertOpen: false,
			modalAlertMessage: "",
            verificationModalOpen: false,
		};

		this.toggleNav = this.toggleNav.bind(this);
		this.toggleDropdown = this.toggleDropdown.bind(this);
		this.toggleDropdown2 = this.toggleDropdown2.bind(this);
		this.toggleNotifications = this.toggleNotifications.bind(this);
		this.toggleNotificationsModal = this.toggleNotificationsModal.bind(this);
		this.handleLoginComplete = this.handleLoginComplete.bind(this);
		this.handleLoginFailed = this.handleLoginFailed.bind(this);
		this.removeNotification = this.removeNotification.bind(this);
		this.hideModalAlert = this.hideModalAlert.bind(this);
		this.showModalAlert = this.showModalAlert.bind(this);
		this.hideVerificationModal = this.hideVerificationModal.bind(this);
		this.showVerificationModal = this.showVerificationModal.bind(this);
		this.loginNewUser = this.loginNewUser.bind(this);
		this.openLoginModal = this.openLoginModal.bind(this);
		this.closeLoginModal = this.closeLoginModal.bind(this);
	}

	componentDidMount() {
		axios.get(serverPath + "authService.php", { params: { action: 'whoIsLoggedIn' } })
			.then((response) => {
				if (response.data !== null) {
					this.setState({ user: response.data });
					this.getNotifications(response.data);

				}
			});
	}
	loginNewUser(username, pass){
		this.handleLogin(username, pass, false);
	}

	handleLoginFailed(){
		this.path = "";
		this.showModalAlert("Pogrešno korisničko ime ili šifra");
	}

	handleLoginComplete(user){
		this.setState({ user: user});
		let tokenValidUntil = new Date(user.tokenValidUntil);
		if(user.isVerified === 0 && new Date() > tokenValidUntil){//account has not been verified and token has expired
			this.showVerificationModal();
		}
		if(user.isVerified === 1){
			this.getNotifications(user);
			if (this.path !== undefined && this.path !== "") {
				if (this.path.indexOf("courses") !== -1) {
					var prefix = this.state.user.roleName.charAt(0);
					this.props.history.push("/" + prefix + this.path);
				} else {
					this.props.history.push(this.path);
				}
				this.path = "";
			}
		}
	}

	openLoginModal(){
		this.setState({
			openLoginModal: true,
		})
	}

	closeLoginModal(){
		this.setState({openLoginModal: false})
	}

	getNotifications(user) {
		if (user !== null) {
			axios.get(serverPath + "notificationService.php", {
				params: {
					action: "getNotifications",
					userId: user.userId,
				}
			}).then((r) => {
				this.setState({
					notificationsData: r.data.new,
					allNotifications: r.data.all,
				});
			})
		}
	}

	toggleNav() {
		this.setState({ isNavOpen: !this.state.isNavOpen });
	}

	toggleNotifications() {
		this.setState({ notificationsOpen: !this.state.notificationsOpen });
	}

	toggleNotificationsModal() {
		this.setState({ notificationsModalOpen: !this.state.notificationsModalOpen });

	}

	toggleDropdown() {
		this.setState({ dropdownOpen: !this.state.dropdownOpen });
	}

    toggleDropdown2() {
        this.setState({ dropdownOpen2: !this.state.dropdownOpen2 });
    }

	showModalAlert(message) {
		this.setState({
			modalAlertMessage: message,
			modalAlertOpen: true
		});
	}

	hideModalAlert() {
		this.setState({
			modalAlertOpen: false,
			modalAlertMessage: ""
		});
	}

	handleLogout() {
		var self = this;
		axios.get(serverPath + 'authService.php', { params: { action: 'logout' } })
			.then(function (_response) {
				self.setState({ user: null });
				self.props.history.push("/home");
			});
	}

	handleClick(path) {
		if (this.state.user === null) {
			/* Public pages */
            if (path.indexOf("/sponsors") !== -1 || path.indexOf("/webgrade") !== -1 || path.indexOf("/team") !== -1) {
                this.props.history.push(path);
			} else {
                this.path = path;
                this.openLoginModal();
            }
		}
		else if(this.state.user.isVerified === 0){
			this.path = path;
			this.showModalAlert("Niste verifikovali nalog! Morate verifikovati nalog da bi nastavili dalje!")
		}
		else {
			if (path.indexOf("courses") !== -1) {
				var prefix = this.state.user.roleName.charAt(0);
				this.props.history.push("/" + prefix + path);
			}
			else {
				this.props.history.push(path);
			}
		}
	}

	removeNotification(submissionId) {
		var newArray = this.state.notificationsData.filter((n) => {
			return (n.Submission_idSubmission !== submissionId)
		});
		this.setState({ notificationsData: newArray });
	}

	showVerificationModal() {
		this.setState({
			verificationModalOpen: true
		});
	}

	hideVerificationModal() {
		this.setState({
			verificationModalOpen: false,
		});
	}

	/*******************************************************RENDER******************************************************/
	render(props) {
		var notifications = this.state.notificationsData.map((data, arrIndex) => {
			var linkRegExp = new RegExp("(http.*?)(?=[)])");
			let location = window.location;
			let hostLen = (location.protocol + "://" + location.hostname).length;
			//link is somtehing like http://localhost/p/........
			//for Link to=href to work properly, we need absolute path, only part /p/...
			let link = data.Message.match(linkRegExp)[0].substr(hostLen-1);

			return (
				<DropdownItem key={arrIndex} tag={Link} to={link}
					onClick={() => {
						this.state.notificationsData.splice(arrIndex, 1);
						let params = new FormData();
						params.append("action", "markAsSeen");
						params.append("idNotification", data.idNotification);
						axios.post(serverPath + "notificationService.php", params);
					}}>
					<div className={'row'} style={{ fontSize: '8px', color: 'grey' }}>
						<div className={'col'} style={{ textAlign: 'left' }}>{convertDatetime(data.timestamp)}</div>
						<div className={'col'} style={{ textAlign: 'right' }}>{data.Sender}</div>
					</div>
					<div className={'row'}>
						<ReactMarkdown source={data.Message} />
					</div>
				</DropdownItem>
			);
		});

		var allNotifications = this.state.allNotifications.map((data, index) => {
			var listGroupItemClass = data.Seen === 0 ? "unread-notifications" : "";
			return (
				<ListGroupItem key={index} className={listGroupItemClass}>
					<div className={'row'} style={{ fontSize: '8px', color: 'grey' }}>
						<div className={'col'} style={{ textAlign: 'left' }}>{convertDatetime(data.timestamp)}</div>
						<div className={'col'} style={{ textAlign: 'right' }}>{data.Sender}</div>
					</div>
					<div className={'row'}>
						<ReactMarkdown source={data.Message} />
					</div>
				</ListGroupItem>
			);
		});

		var notificationClasses = "fa fa-bell";
		if (this.state.notificationsData.length > 0) {
			notificationClasses += " unread-notifications";
		}

		return (
			<div>
				<Modal isOpen={this.state.notificationsModalOpen}
					toggle={this.toggleNotificationsModal}>
					<ModalHeader toggle={this.toggleNotificationsModal}>
						Sva obaveštenja u poslednja 3 meseca
                        </ModalHeader>
					<ListGroup>
						{allNotifications}
					</ListGroup>

				</Modal>
				<Navbar dark expand="md">
					<div className="container ml-2 mr-2">
						<NavbarToggler onClick={this.toggleNav} />
						<NavbarBrand className="mr-auto" href="/">
							<img src={logo} width="50" alt='Webgrade@MATF' />
						</NavbarBrand>
						<Collapse isOpen={this.state.isNavOpen} navbar>
							<Nav navbar>
								<NavItem>
									<NavLink className="nav-link" to='/home'> Početna </NavLink>
								</NavItem>
								<Dropdown nav isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown}>
									<DropdownToggle nav caret>
										Kursevi
                                    </DropdownToggle>
									<DropdownMenu>
										<DropdownItem onClick={(event) => this.handleClick("/courses/1")}>
											<span> Programiranje 1 (M, N, V, L, R)</span>
										</DropdownItem>
										<DropdownItem onClick={(event) => this.handleClick("/courses/5")}>
											<span> Programiranje 2 (M, N, V, L, R)</span>
										</DropdownItem>
										<DropdownItem divider />
                                        <DropdownItem onClick={(event) => this.handleClick("/courses/3")}>
                                            <span> Programiranje 1 - Izdvojeni zadaci</span>
                                        </DropdownItem>
										<DropdownItem onClick={(event) => this.handleClick("/courses/2")}>
											<span> Programiranje 1 (I)</span>
										</DropdownItem>
										<DropdownItem onClick={(event) => this.handleClick("/courses/4")}>
											<span> Programiranje 2 (I)</span>
										</DropdownItem>
										<DropdownItem divider />
										<DropdownItem onClick={(event) => this.handleClick("/courses/6")}>
											<span> Operativni sistemi </span>
										</DropdownItem>
										<DropdownItem divider />
                                        <DropdownItem onClick={(event) => this.handleClick("/courses/7")}>
                                            <span> Dizajn programskih jezika </span>
                                        </DropdownItem>
                                        <DropdownItem onClick={(event) => this.handleClick("/courses/8")}>
                                            <span> Programske paradigme (R) </span>
                                        </DropdownItem>
                                        <DropdownItem onClick={(event) => this.handleClick("/courses/9")}>
                                            <span> Programske paradigme (I) </span>
                                        </DropdownItem>
									</DropdownMenu>
								</Dropdown>
								<NavItem onClick={(event) => this.handleClick("/algorithms")} className="nav-link">
									Algoritamski zadaci
                                </NavItem>
                                <Dropdown nav isOpen={this.state.dropdownOpen2} toggle={this.toggleDropdown2}>
                                    <DropdownToggle nav caret>
                                        O nama
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem onClick={(event) => this.handleClick("/webgrade")}>
                                            <span> O projektu </span>
                                        </DropdownItem>
                                        <DropdownItem onClick={(event) => this.handleClick("/team")}>
                                            <span> WebGrade tim </span>
                                        </DropdownItem>
                                        {/*<DropdownItem divider />*/}
                                        {/*<DropdownItem onClick={(event) => this.handleClick("/guestbook")}>*/}
                                            {/*<span> Iskustva korisnika </span>*/}
                                        {/*</DropdownItem>*/}
                                        {/*<DropdownItem divider />*/}
                                        {/*<DropdownItem onClick={(event) => this.handleClick("/sponsors")}>*/}
                                            {/*<span> Sponzori </span>*/}
                                        {/*</DropdownItem>*/}
                                    </DropdownMenu>
                                </Dropdown>
								{/*<NavItem>*/}
									{/*<NavLink className="nav-link" to='/sponsors'> Sponzori </NavLink>*/}
								{/*</NavItem>*/}
							</Nav>

							<Nav className="ml-auto" navbar>
								{

									this.state.user !== null &&
									<Dropdown nav isOpen={this.state.notificationsOpen}
										toggle={this.toggleNotifications}>
										<DropdownToggle nav caret>
											<span className={notificationClasses}/>
										</DropdownToggle>
										<DropdownMenu right className={'text-center'}>
											{notifications}
											{
												this.state.allNotifications.length > 0 ?
													<Button onClick={this.toggleNotificationsModal}
														color={'primary'}>Sva obaveštenja</Button>
													:
													<p>Nema obaveštenja</p>
											}
										</DropdownMenu>
									</Dropdown>

								}
								<NavItem className="mx-1">
									{this.state.user !== null ?
										<NavLink className="nav-link" to={'/user/' + this.state.user.username}>
											<span className="fa fa-user-circle"> </span>
											{this.state.user.username}
										</NavLink>
										:
                                        <LoginModal loginComplete={this.handleLoginComplete}
                                                    loginFailed={this.handleLoginFailed}
													parentWantsModal={this.state.openLoginModal}
													handleClose={this.closeLoginModal}/>


									}
								</NavItem>
								{this.state.user !== null ?
									<NavItem>
										<Button color="info" outline onClick={(event) => this.handleLogout()}>

											<span className="fa fa-sign-in fa-lg"> </span> Odjavi se
                                        </Button>
									</NavItem> : <span/>
								}
								{
									this.state.user === null ?
										<SignupModal loginHandler={this.loginNewUser}/>
										:
										<span/>
								}
							</Nav>
						</Collapse>
					</div>
					<ModalAlert showModal={this.state.modalAlertOpen} message={this.state.modalAlertMessage}
						closeModalHandler={this.hideModalAlert} />
					<SignupVerificationModal isOpen={this.state.verificationModalOpen} firstTime={false}
											 closeModalHandler={this.hideVerificationModal}/>
				</Navbar>

				<Switch>

					<Route path="/home" component={HomePage} />
					<Route path="/news" render={(props) => <News onHome={false} {...props} />} />

					{/*Student*/}
					<Route path="/s/courses/:courseId"
						render={(props) =>
							<StudentCourseHomePage removeNotification={this.removeNotification} {...props} />} />
					{/*<Route path="/s/problem/:problemId" component={ProblemDetails} />*/}
					<Route path="/user/:username" render={(props) => {
						return (
							<StudentPage key={props.match.params.username} {...props} />
						);
					}} />
					<Route path="/algorithms" component={AllProblemsPage} />
					<Route path="/sponsors" component={Sponsors} />
					<Route path="/webgrade" component={AboutWebGrade} />
					<Route path="/team" component={WebGradeTeam} />

					{/*Professor*/}
					<Route path="/p/courses/:courseId" render=
						{(props) =>
							<PCourseHomePage {...props}
								key={props.match.params.courseId} />}
					/>

					{/* for both student and otherUser */}
					<Route path="/:prefix/problem/:problemId" component={ProblemDetails} />
					{/*Default*/}
					<Redirect to="/home" />
				</Switch>

				<footer>
					Webgrade@MATF, 2019
                </footer>
			</div>
		);
	}
}

export default MainLayout;
